export default __webpack_public_path__ + "static/4-52f1081539805c397c3b9ca2ab5f94bd.jpeg";